export class CustomerType {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new CustomerType(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/customer-type.ts